module.exports = __webpack_public_path__ + "Opps_error.svg";